// initial state
const state = {
  all: [],
  groups: [],
  defaultFields: [],
  groupRevision: 0,
  auditlogRequestID: 0,
  auditlogLoading: false,
  auditlogPending: false,
  manualEntryResult: {
    revision: 0,
    ok: false,
    error: ''
  },
  count: 0,
  missingReasons: 0,
  toolsLog: 'Loading...',
  emailBounceOverview: {
    total_recent: 0,
    hard_bounces: 0,
    deferred: 0,
    rate_limited: 0,
    alarmable_recent: 0,
    non_alarm_recent: 0,
    blacklist_recent: 0,
    threshold: 10,
    deferred_threshold: 5,
    window_minutes: 15,
    log_read_limit: 5000,
    recent_limit: 250,
    alarm_active: false,
    active_alerts: [],
    by_reason: {},
    by_provider: [],
    recent: []
  },
  emailRoutingRules: {
    default: 'namecheap',
    rules: [],
    updated_at: null
  }
}

// getters
const getters = {
  Auditlog: state => state.all,
  AuditlogGroups: state => state.groups,
  AuditlogDefaultFields: state => state.defaultFields,
  AuditlogGroupRevision: state => state.groupRevision,
  AuditlogLoading: state => state.auditlogLoading,
  AuditlogPending: state => state.auditlogPending,
  AuditlogManualEntryResult: state => state.manualEntryResult,
  LogCount: state => state.count,
  AuditlogMissingReasons: state => state.missingReasons,
  ToolsLog: state => state.toolsLog,
  EmailBounceOverview: state => state.emailBounceOverview,
  EmailRoutingRules: state => state.emailRoutingRules,
}

// actions
const actions = {
  getAuditlog ({ commit }, trades) {
    commit('setAuditlog', trades.data)
  },
  getAuditlogCount ({ commit }, payload) {
    commit('setAuditlogCount', payload.data)
  },
  getAuditlogMissingReasons ({ commit }, payload) {
    commit('setAuditlogMissingReasons', payload.data)
  },
  getAuditLogGroupEntries ({ commit }, payload) {
    commit('setAuditLogGroupEntries', payload.data)
  },
  startAuditlogLoading ({ commit }, request) {
    commit('startAuditlogRequest', request)
  },
  createManualAuditLogEntryResult ({ commit }, result) {
    commit('setManualEntryResult', result.data)
  },
  auditLogGroupsChanged ({ commit }) {
    commit('incrementAuditLogGroupRevision')
  },
  getToolslog ({ commit }, trades) {
    commit('setToolslog', trades.data)
  },
  getEmailBounceOverview ({ commit }, payload) {
    commit('setEmailBounceOverview', payload.data)
  },
  getEmailRoutingRules ({ commit }, payload) {
    commit('setEmailRoutingRules', payload.data)
  },
  ClearLog ({ commit }, trades) {
    commit('clearToolslog')
  },
  clearAuditlog ({ commit }) {
    commit('clearAuditlog')
  }
}

// mutations
const mutations = {
  setAuditlog (state, log) {
    if (log.request_id && log.request_id !== state.auditlogRequestID) {
      return
    }
    state.all = log.entries
    state.groups = log.groups || []
    state.defaultFields = log.default_fields || []
    if (log.missing_reasons_included) {
      state.missingReasons = log.missing_reasons || 0
    }
    if (log.count_included) {
      state.count = log.count || 0
    }
    state.auditlogLoading = false
    state.auditlogPending = false
  },
  setAuditlogMissingReasons (state, payload) {
    if (payload.request_id && payload.request_id !== state.auditlogRequestID) {
      return
    }
    state.missingReasons = payload.missing_reasons || 0
  },
  setAuditlogCount (state, payload) {
    if (payload.request_id && payload.request_id !== state.auditlogRequestID) {
      return
    }
    state.count = payload.count || 0
  },
  setAuditLogGroupEntries (state, payload) {
    const groupID = Number(payload && payload.group_id)
    if (!groupID) {
      return
    }
    const entries = Array.isArray(payload.entries) ? payload.entries : []
    state.groups = state.groups.map(group => {
      if (!group || Number(group.id) !== groupID) {
        return group
      }
      const expectedVisibleCount = Number(group.visible_member_count || 0)
      const loaded = entries.length > 0 || expectedVisibleCount === 0
      return {
        ...group,
        entries,
        visible_member_count: entries.length > 0 ? entries.length : expectedVisibleCount,
        members_loaded: loaded,
        load_failed: !loaded
      }
    })
  },
  startAuditlogRequest (state, request) {
    state.auditlogRequestID = Number(request && request.requestID) || 0
    state.auditlogLoading = Boolean(request && request.loading)
    state.auditlogPending = true
  },
  setManualEntryResult (state, result) {
    state.manualEntryResult = {
      revision: state.manualEntryResult.revision + 1,
      ok: Boolean(result && result.ok),
      error: result && result.error ? result.error : ''
    }
  },
  clearAuditlog (state) {
    state.all = []
    state.groups = []
    state.defaultFields = []
    state.missingReasons = 0
    state.auditlogLoading = false
    state.auditlogPending = false
  },
  incrementAuditLogGroupRevision (state) {
    state.groupRevision++
  },
  clearToolslog (state) {
    state.toolsLog = 'Loading...'
  },
  setToolslog (state, log) {
    state.toolsLog = log
  },
  setEmailBounceOverview (state, overview) {
    state.emailBounceOverview = overview
  },
  setEmailRoutingRules (state, payload) {
    state.emailRoutingRules = payload
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}
